import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "transition-all duration-300 ease-out",
          "focus:animate-scale-in focus:border-primary focus:shadow-[0_0_15px_rgba(239,120,16,0.3)] focus:bg-gradient-to-r focus:from-background focus:to-background/80",
          "hover:border-primary/50 hover:shadow-[0_0_8px_rgba(239,120,16,0.15)]",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
